import { render, staticRenderFns } from "./ad-customer-ad-editor.vue?vue&type=template&id=23035391&scoped=true&"
import script from "./ad-customer-ad-editor.vue?vue&type=script&lang=js&"
export * from "./ad-customer-ad-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23035391",
  null
  
)

export default component.exports